import { apiClient } from "./apiClient";
import { endpoints } from "./endpoints";
import type { ApiRecord } from "@/types/api";

export const healthService = {
  async getLiveness(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.health.live);
    return response.data;
  },
  async getReadiness(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.health.ready);
    return response.data;
  },
};
